import "reflect-metadata";
import Head from "next/head";
import { useRouter } from "next/router";
import { GlobalProviders } from "@emed/virtual-lab-ui-shared/providers/_GlobalProviders";
import { EnvironmentProvider } from "@emed/virtual-lab-ui-shared/providers/EnvironmentProvider";
import { LogProvider } from "@emed/virtual-lab-ui-shared/providers/LogProvider";
import { ThemeProvider } from "@emed/virtual-lab-ui-shared/providers/ThemeProvider";
import { LanguageProvider, LanguageUtils } from "@emed/virtual-lab-ui-shared/providers/LanguageProvider";
import { Trans } from "@emed/virtual-lab-ui-shared/providers/TranslationProvider";
import { translations } from "@emed/virtual-lab-ui-shared/content/translations";
import "../styles/globals.scss";
import "@emed-labs/ui-kit/styles.css";

// Minimal providers for test pages that don't need session management
function MinimalProviders({ children }) {
	return (
		<EnvironmentProvider>
			<LogProvider>
				<LanguageProvider language={LanguageUtils.getUserLanguage()}>
					<Trans.container resources={translations}>
						<ThemeProvider>
							{children}
						</ThemeProvider>
					</Trans.container>
				</LanguageProvider>
			</LogProvider>
		</EnvironmentProvider>
	);
}

function MyApp({ Component, pageProps }) {
	const router = useRouter();
	
	// Pages that should use minimal providers (no session management)
	const minimalProviderPages = ["/test-postmessage"];
	const useMinimalProviders = minimalProviderPages.includes(router.pathname);
	
	const Providers = useMinimalProviders ? MinimalProviders : GlobalProviders;
	
	return (
		<Providers>
			<>
				<Head>
					<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
				</Head>
				<Component {...pageProps} />
			</>
		</Providers>
	);
}

export default MyApp;
